import { useMemo } from 'react'

import { useAppDispatch } from '@app/utils/redux'

import { getState } from '@app/store/actions/initial'

export const useImmutableSelector = <TValue extends any>(selector: (state: unknown) => TValue): TValue => {
  const dispatch = useAppDispatch()
  return useMemo(() => {
    return dispatch(getState(selector))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
